export async function profileImage(src){
 const image=new Image();
 await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=()=>reject(new Error('photoInvalidFile'));image.src=src;});
 if(image.naturalWidth<160||image.naturalHeight<160||image.naturalWidth*image.naturalHeight>40000000)throw new Error('photoInvalidFile');
 return image;
}
export async function croppedProfilePhoto(src,area){
 const image=await profileImage(src),values=area&&[area.x,area.y,area.width,area.height];
 if(!values||values.some(x=>!Number.isFinite(x))||area.x<0||area.y<0||area.width<160||area.height<160||area.x+area.width>image.naturalWidth+1||area.y+area.height>image.naturalHeight+1)throw new Error('photoCropTooSmall');
 const canvas=document.createElement('canvas'),size=Math.min(1024,Math.round(Math.min(area.width,area.height)));
 canvas.width=size;canvas.height=size;
 try{
  const context=canvas.getContext('2d');if(!context)throw new Error('photoUnavailable');
  context.fillStyle='#fff';context.fillRect(0,0,size,size);
  context.drawImage(image,area.x,area.y,area.width,area.height,0,0,size,size);
  const blob=await new Promise((resolve,reject)=>canvas.toBlob(value=>value?resolve(value):reject(new Error('photoUnavailable')),'image/jpeg',.9));
  return new File([blob],'profile-photo.jpg',{type:'image/jpeg'});
 }finally{canvas.width=1;canvas.height=1;}
}
